import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Photo Mosaic Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform='twitter' />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/mosaic/create/index.js